import { createContext } from 'react';

/** @type {Context<useStateReturn<{ resetHandlers: (() => void)[] }>>} */
export const GridFilterDropdownContext = createContext([{}, () => null]);
